"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = require("react");
function useLastValue(value) {
    const ref = react_1.useRef([]);
    const hasChanged = ref.current[1] !== value;
    react_1.useEffect(() => {
        if (hasChanged) {
            ref.current[0] = ref.current[1];
            ref.current[1] = value;
        }
    });
    return hasChanged ? ref.current[1] : ref.current[0];
}
exports.useLastValue = useLastValue;
//# sourceMappingURL=useLastValue.js.map